import React, { act, useEffect, useState } from "react";
import { initializeApp } from "firebase/app";
import { getDatabase, ref, onValue } from "firebase/database";

// panel247
const firebaseConfig = {
  apiKey: "AIzaSyAmVgpv5V0hwq4UBQtllRDTsFO3jRz4TzE",
  authDomain: "panel247.firebaseapp.com",
  databaseURL: "https://panel247-default-rtdb.firebaseio.com",
  projectId: "panel247",
  storageBucket: "panel247.firebasestorage.app",
  messagingSenderId: "756063305702",
  appId: "1:756063305702:web:3999d5872675e5a81de027",
  measurementId: "G-RN1S4PLPDW",
};
// multi
// const firebaseConfig = {
//   apiKey: "AIzaSyBD9QAogmef5vWG1hqNGgKqUDMip-QHRtU",
//   authDomain: "multiclicker-6a3c9.firebaseapp.com",
//   databaseURL: "https://multiclicker-6a3c9-default-rtdb.firebaseio.com",
//   projectId: "multiclicker-6a3c9",
//   storageBucket: "multiclicker-6a3c9.firebasestorage.app",
//   messagingSenderId: "788043626099",
//   appId: "1:788043626099:web:0ef51c22bb2ef5aedddc06",
//   measurementId: "G-0K19XGHLZY",
// };
// status
// const firebaseConfig = {
//   apiKey: "AIzaSyCqoQXWG11TJ2ZlWuHCise7tZ2SkoJr-kY",
//   authDomain: "personal-2e64f.firebaseapp.com",
//   databaseURL: "https://personal-2e64f-default-rtdb.firebaseio.com",
//   projectId: "personal-2e64f",
//   storageBucket: "personal-2e64f.firebasestorage.app",
//   messagingSenderId: "258888089138",
//   appId: "1:258888089138:web:58d8785a628c6acf5c062b",
//   measurementId: "G-261T35PTXN",
// };
// redtwo
// const firebaseConfig = {
//   apiKey: "AIzaSyDfYRuzsZ5juXBEKyQqoqULpxzjQfdRo28",
//   authDomain: "spyredtwo.firebaseapp.com",
//   databaseURL: "https://spyredtwo-default-rtdb.firebaseio.com",
//   projectId: "spyredtwo",
//   storageBucket: "spyredtwo.firebasestorage.app",
//   messagingSenderId: "950975986873",
//   appId: "1:950975986873:web:c4fd6136ebf80cf74daf68",
//   measurementId: "G-SSMMTVGBY4"
// };
// status777
// const firebaseConfig = {
//   apiKey: "AIzaSyD1db9KQNjfIDGYY2qn0xkhq6o8QPWUo_E",
//   authDomain: "panel777-756b6.firebaseapp.com",
//   databaseURL: "https://panel777-756b6-default-rtdb.firebaseio.com",
//   projectId: "panel777-756b6",
//   storageBucket: "panel777-756b6.firebasestorage.app",
//   messagingSenderId: "186202213667",
//   appId: "1:186202213667:web:97be13f1a4063da0fd5096",
//   measurementId: "G-G6PRYHQ1J3",
// };

//redthree
// const firebaseConfig = {
//   apiKey: "AIzaSyDwKQOzEmqd98ndcKx4GtDD2tlyJGCCvck",
//   authDomain: "redthree-f0666.firebaseapp.com",
//   databaseURL:
//     "https://redthree-f0666-default-rtdb.asia-southeast1.firebasedatabase.app",
//   projectId: "redthree-f0666",
//   storageBucket: "redthree-f0666.firebasestorage.app",
//   messagingSenderId: "26891539826",
//   appId: "1:26891539826:web:4641356e16b4cee215b9eb",
//   measurementId: "G-EGJT6RW1PD",
// };

const app = initializeApp(firebaseConfig);
const db = getDatabase(app);

export default function App() {
  const [activeUser, setActiveUser] = useState({});

  useEffect(() => {
    const activeSession = ref(db, "activeSession/");

    const unsubscribe = onValue(activeSession, (snapshot) => {
      const data = snapshot.val() || {};
      setActiveUser(data);
    });

    return () => unsubscribe();
  }, []);

  const activeUserName = Object.keys(activeUser);

  return (
    <div className="row">
      {activeUserName.map((item) => (
        <div
          key={item}
          className="col-6 col-md-2 border"
          style={{ padding: 20, height: 300 }}
        >
          <div className="heading text-center">
            <h6>{item}</h6>
            <span style={{ fontSize: 14 }}>
              Last updated at{" "}
              {new Date(activeUser[item]?.lastupdated).toString()}
            </span>
          </div>

          <h6>Bal: {activeUser[item]?.bal}</h6>
          <h6>Exp: {activeUser[item]?.exp}</h6>

          <h6>Url:</h6>
          <span style={{ wordWrap: "break-word" }}>
            {activeUser[item]?.url}
          </span>
        </div>
      ))}
    </div>
  );
}
